const routes = {
  HOME: "/home",
};

export default routes;
